<!--
  @description 门户网五库列表页 底部分页
  @author wlj
-->
<template>
    <div id="model-page">
        <el-pagination
            :page-size="pageSize"
            :total="total"
            layout="prev,pager,next,jumper,slot"
            class="mt-3 text-center"
            :current-page.sync="curPage"
            hide-on-single-page
            :pager-count="5"
            @current-change="jumperPage">
            <div class="user-custom">
                <span class="tip-allPage">共<i>{{ Math.ceil(parseInt(total) / parseInt(pageSize)) }}</i>页</span>
                <el-button class="btn-jumpage" @click="enterJumperPage">确定</el-button>
            </div>
        </el-pagination>
    </div>
</template>

<script>
export default {
    name: "Pagination",
    props: ["pageSize", "total", "currentPage"],
    data() {
        return {
            pagerCount: 10,
            curPage: this.currentPage
        }
    },
    watch: {
        currentPage() {
            this.curPage = this.currentPage;
        }
    },
    methods: {
        jumperPage(val) {
            this.windowScrollTop();
            this.$emit('parentMethod', val);
        },
        enterJumperPage(){
            this.windowScrollTop();
            let val = document.getElementsByClassName('el-pagination__jump')[0].firstElementChild.firstElementChild.value;
            this.$emit('parentMethod', parseInt(val));
        },
        // 滚动条动画置顶
        windowScrollTop() {
            this.$store.dispatch("scrollToTop");
        }
    }
}
</script>

<style lang="scss">
$col356: #213752;
#model-page {
    .el-pagination {

        color: #666;
        .btn-prev,
        .btn-next {
            height: 40px;
        }
        .el-pager li {
            width: 40px;
            height: 40px;
            line-height: 40px;
            border: 1px solid #DEE0CC;
            margin-right: 8px;
            font-weight: 500;
            font-size: 14px;
            &.active {
                border-color: $col356;
                font-weight: 700;
                font-size: 16px;
            }
            &:last-child {
                margin-right: 0px;
            }
        }
        .el-pagination__jump {
            margin-top: 3px;
            margin-left: 90px;
            color: #898d7e;
            font-size: 14px;
        }
        .el-pagination__editor.el-input .el-input__inner {
            width: 40px;
            height: 32px;
            color: #666;
        }
        .user-custom {
            position: relative;
            display: inline-block;
            .tip-allPage {
                position: absolute;
                font-weight: 500;
                left: -164px;
                top: 6px;
                color: #898d7e;
                font-size: 14px;
                i {
                    margin: 0 4px;
                    font-style: normal;
                    color: #666;
                }
            }
            .btn-jumpage {
                border: 1px solid #DEE0CC;
                margin-left: 16px;
                margin-top: 4px;
                padding: 0 8px;
                height: 31px;
                span {
                    font-size: 14px;
                    color: #666;
                }
                &:hover {
                    border-color: $col356;
                }
            }
        }
    }
}
</style>
